import React, { useState } from "react";
import { Typography, Button, Row, Col, message } from "antd";
import LogoImg from "../../../assets/images/smallLogo.png";
import BannerImg from "../../../assets/images/banner.png";
import { Link, Navigate, useNavigate } from "react-router-dom";
import BackArrowImg from "../../../assets/images/arrowLeft.png";
import OtpInputBox from "./OtpInputBox";
import { useDispatch, useSelector } from "react-redux";
import { verifyOtpAction } from "../../../redux/reducer/AuthSlice";
import axios from "axios";

const { Title, Text } = Typography;

const VerifyOtp = () => {
  const [otp, setOtp] = useState("");
  const dispatch = useDispatch();
  const [verifyLoading, setverifyLoading] = useState(false)
  const [verifyError, setverifyError] = useState(false)
  const { loading, error, success, forgetData } = useSelector((state) => state.auth);
  const navigate = useNavigate()
 


  const handleOtpSubmit = (otp) => {
    setOtp(otp);
  };

  const handleVerifyClick = async () => {
  
    if (!otp) {
      message.error("Please enter OTP");
      return;
    }

    setverifyLoading(true)
    const headers = {
      Authorization: `Bearer ${forgetData}`, // Ensure forgetData contains a valid token
      "Content-Type": "application/json",
      "x-api-key": process.env.REACT_APP_API_KEY,
    };
  
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URI}/admin/auth/otp/verify`, // Ensure the correct base URL
        { otp },  // Request body
        { headers } // Headers
      );
  
    
      localStorage.setItem("verifyToken", response?.data?.result)
  
      if (response?.status === 202) {
        setverifyLoading(false)
        navigate('/reset-password')
        message.success("OTP Verified Successfully");
      } else {
        message.error(response?.data?.message || "OTP verification failed");
      }
    } catch (error) {
      setverifyLoading(false)
      setverifyError(true)
      console.error("Error verifying OTP:", error);
      message.error(error?.response?.data?.message || "API request failed");
    }
  };

  return (
    <div className="signinContainer">
      <Row gutter={16} className="signinRow">
        <Col xs={24} sm={12}>
          <div className="leftSection cflex">
            <div className="leftContainer">
              <img src={LogoImg} alt="Logo" className="logo" />
              <Link to="/" className="backToLogin mt-3">
                <img src={BackArrowImg} alt="BackArrowImg" /> Back To Login
              </Link>
              <Title level={2}>Verify OTP</Title>
              <Text className="subtitle mb-2">
                We have sent a verification code to your provided email address.
                Please enter the code below.
              </Text>
              <form className="signin-form" onSubmit={(e) => e.preventDefault()}>
                <div className="otpBx">
                  <OtpInputBox onOtpSubmit={handleOtpSubmit} />
                </div>
                <div className="mart-10">
                {verifyError ? <p className="error-message">Please Enter valid OTP</p> : ""}
                </div>

                <Button
                  type="primary"
                  className="customButton mt-3"
                  onClick={handleVerifyClick}
                  loading={verifyLoading}
                  disabled={loading}
                >
                  Verify
                </Button>
                {error && <Text type="danger" className="mt-2">{error}</Text>}
                {success && <Text type="success" className="mt-2">OTP Verified!</Text>}
                <Text className="subtitle mt-5 text-center">
                  © Cultivate 2025
                </Text>
              </form>
            </div>
          </div>
        </Col>

        <Col xs={24} sm={12}>
          <div className="rightSection cflex">
            <img src={BannerImg} alt="Banner" className="banner" />
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default VerifyOtp;


